import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorage, LocalStorageUtil } from '../../utils/local-storage-util';
import { Alert, AlertType } from '../models/alert';
import { LocationFormatter } from '../models/location-formater.model';
import { SbToastService } from './sb-toast.service';
import { ObjectUtil } from '../../utils/object-util';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  storage: LocalStorage = LocalStorageUtil.getStorage();

  constructor(
    private router: Router,
    private toastMessage: SbToastService,
  ) {}

  public getServerErrorMessage(error: any) {
    console.warn(error?.code);
    console.warn(error);
    switch (error?.error?.code) {
      case 400:
        if (error?.error?.errors?.length > 0) {
          let errorMsg = '';
          error?.error?.errors?.forEach((e: any) => {
            errorMsg =
              errorMsg +
              ' ' +
              (ObjectUtil.isEmpty(e?.message)
                ? e?.field + ' cannot be null'
                : e?.message) +
              ' ';
          });

          this.toastMessage.showToastMessage(
            new Alert(AlertType.ERROR),
            errorMsg,
          );
        } else {
          this.toastMessage.showToastMessage(
            new Alert(AlertType.ERROR),
            error?.error?.message,
          );
        }
        console.error(`Bad  Request: ${error?.error?.message}`);
        break;
      case 401:
        this.toastMessage.showToastMessage(
          new Alert(AlertType.ERROR),
          error?.message,
        );
        console.error(`Unauthorized: ${error?.message}`);
        break;
      case 404:
        this.toastMessage.showToastMessage(
          new Alert(AlertType.ERROR),
          error?.message,
        );
        console.error(`Not Found: ${error?.message}`);
        break;
      case 403:
        this.toastMessage.showToastMessage(
          new Alert(AlertType.ERROR),
          error?.message,
        );
        console.error(`Access Denied: ${error?.message}`);
        break;
      case 500:
        this.toastMessage.showToastMessage(
          new Alert(AlertType.ERROR),
          error?.message,
        );
        console.error(`Internal Server Error: ${error?.message}`);
        break;
      default:
        this.toastMessage.showToastMessage(
          new Alert(AlertType.ERROR),
          error?.message
            ? `${error?.message}`
            : 'Something went wrong. Unknown Server Error',
        );
        console.error(
          `Something went wrong. Unknown Server Error: ${error?.message}`,
        );
        break;
    }
  }

  getHttpSuccessResponseMessage(response: any) {
    console.warn('response: ', response);
    switch (response.code) {
      case 200:
        this.toastMessage.showToastMessage(
          new Alert(AlertType.INFO),
          response.message,
        );
        console.warn(`Response fetched: ${response.message}`);
        break;
      case 201:
        this.toastMessage.showToastMessage(
          new Alert(AlertType.SUCCESS),
          response.message,
        );
        console.warn(`Data saved: ${response.message}`);
        break;
      case 204:
        this.toastMessage.showToastMessage(
          new Alert(AlertType.INFO),
          response.message,
        );
        console.warn(`Data saved: ${response.message}`);
        break;
      default:
        console.warn('');
        break;
    }
  }

  redirectTo(uri: string) {
    console.warn('uri: ', uri);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([uri]));
  }

  refreshDataHavingRouterOutletNavigation(uri: string) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([uri]);
  }

  mapLocationDetails(data: any): string {
    let locationDetails: Array<LocationFormatter> =
      new Array<LocationFormatter>();

    let locationFormatter: LocationFormatter = new LocationFormatter();

    locationFormatter.permanentAddress = data?.locationDetails[0];

    if (data?.locationDetails?.length > 1) {
      locationFormatter.temporaryAddress = data?.locationDetails[1];
    }

    if (data?.addressMatched) {
      locationFormatter.temporaryAddress = data?.locationDetails[0];
    }
    locationFormatter.addressMatched = data?.addressMatched;

    locationDetails.push(locationFormatter);

    return JSON.stringify(locationDetails);
  }

  reverseMapLocationDetailsForEdit(data: string): any {
    let locationDetails: Array<LocationFormatter> =
      new Array<LocationFormatter>();
    locationDetails = Array.from(JSON.parse(data));
    let reverseLocationDetails: Array<any> = new Array<any>();
    for (let i = 0; i < 2; i++) {
      reverseLocationDetails[i] = [];
    }
    reverseLocationDetails[0] = locationDetails[0]?.permanentAddress;
    if (data.length > 1) {
      reverseLocationDetails[1] = locationDetails[0]?.temporaryAddress;
    }
    reverseLocationDetails = reverseLocationDetails.filter(
      (f) => !ObjectUtil.isEmpty(f?.country),
    );
    return Object.assign({ locationDetails: reverseLocationDetails });
  }

  static appendNewDataAsObjectIntoExistingStorageUtils(
    ObjKey: string,
    key: string,
    value: any,
  ) {
    const storageDetails: LocalStorageUtil | any =
      LocalStorageUtil.getStorage();
    storageDetails[ObjKey] = storageDetails[ObjKey] || {};
    storageDetails[ObjKey][key] = value;

    LocalStorageUtil.setStorage(storageDetails);
  }

  scrollToFirstInvalidControl(el: any) {
    const firstInvalidControl: HTMLElement =
      el?.nativeElement?.querySelector('form .ng-invalid');
    if (firstInvalidControl) {
      firstInvalidControl.scrollIntoView({ behavior: 'smooth' });
      firstInvalidControl.focus();
    }
    const errors: any[] = [];
    const elements: [] =
      el?.nativeElement?.querySelectorAll('form .ng-invalid');
    elements.forEach((e: any) => {
      let text = '';
      if (e?.labels !== undefined) {
        let a: any = e?.labels[0];
        if (a != undefined) {
          text = a?.innerText?.replaceAll('*', '').trim();
        } else {
          text = e?.name?.toUpperCase();
        }
      } else {
        text = e?.innerText
          ?.replaceAll('Select', '')
          ?.replaceAll('*', '')
          .trim();
      }

      if (!errors.includes(text)) {
        errors.push(text.trim());
      }
    });
    let finalMsg = errors[0] + ' is Required.';
    if (errors.length > 1) {
      let errorMessage = '';
      if (errors.length <= 5) {
        for (let i = 1; i < errors.length; i++) {
          errorMessage += errors[i] + ',';
        }
      } else {
        for (let i = 1; i < 5; i++) {
          errorMessage += errors[i] + ',';
        }
        errorMessage += '....';
      }

      this.toastMessage.showToastMessage(
        new Alert(AlertType.ERROR),
        errorMessage + ' is Required.',
      );
      // this.toastMessage.showToastMessage(new Alert(AlertType.ERROR),  'Please fill all required fields before proceeding!');
    } else {
      this.toastMessage.showToastMessage(new Alert(AlertType.ERROR), finalMsg);
    }

    console.error('errors: ', errors);
    // let finalMsg = errors.filter((f: any) => f !== '').map((e: any) => e + ' is Required.').join('</br>');

    const msgAlert = {
      msg: '<b>' + finalMsg + '</b>',
      alertType: AlertType.ERROR,
    };
    this.toastMessage.subject.next(msgAlert);
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return (
      controlEl?.getBoundingClientRect().top + window.scrollY - labelOffset
    );
  }

  public static setDataForCustomerFeedback(form: any) {
    return {
      periodOfFacility: form.get('periodOfFacility')?.value,
      purposeOfLoan: form.get('purposeOfLoan')?.value,
      repaymentPlan: form.get('repaymentPlan')?.value,
      detailsOfLoanRequested: form.get('detailsOfLoanRequested')?.value,
    };
  }

  generatePDF(data: any, type: number, fileName: string) {
    const formData = new FormData();
    html2canvas(data).then((canvas) => {
      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const heightLeft = imgHeight;
      console.log('formdata', 'test');
      const contentDataURL = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
      // if (type === 0) {

      const blob = pdf.output('blob');
      console.log(blob);
      const blob1 = pdf.output();

      formData.set('file', blob);
      formData.append('test', 'blob');
      formData.append('pdf', blob);

      console.log('formdata', formData);

      // }
      // return pdf.save(fileName);
    });
    return formData;
  }

  formattingAddress(value: any) {
    return !ObjectUtil.isEmpty(value) &&
      !ObjectUtil.isEmpty(value.locationDetails)
      ? this.mapLocationDetails(value)
      : value;
  }
}
